import dClient from "../../Components/api/reduxLoaderApi";
import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";
import {initAgencyForm, setProvinces} from "./agencySlice";


export const getAgencyById = ({id}, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `agency/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(initAgencyForm(res.data.data))
    return callback && callback();
};

export const getProvinces = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `location/province`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(setProvinces(res.data.provinces))
    // dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const createAgency = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `agency`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const editAgency = (id, data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'put',
        `agency/${id}`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};
export const deleteAgency = (id, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `agency/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت حذف شد</h3>, false))
    return callback && callback();
};